import { Typography } from "antd";

const PurchasesOverview = () => {
  return <Typography>PurchasesOverview</Typography>;
};

export default PurchasesOverview;
